import { Link as InertiaLink } from '@inertiajs/react'

import { ImportHistory, type ImportHistoryProps } from '@components/imports/ImportHistory'
import { PageLayout } from '@components/layouts/PageLayout'
import {
  GroupPageHeader,
  type GroupPageHeaderProps,
} from '@frontend/contexts/supporters-management/features/group-page/GroupPageHeader'

export type GroupImportsIndexProps = ImportHistoryProps & { groupHeader: GroupPageHeaderProps }

export default function GroupImportsIndex({ groupHeader, ...history }: GroupImportsIndexProps) {
  return (
    <PageLayout.Root>
      <GroupPageHeader {...groupHeader} linkComponent={InertiaLink} />
      <PageLayout.Body>
        <ImportHistory {...history} />
      </PageLayout.Body>
    </PageLayout.Root>
  )
}
